import type {
  SeasonCardKakaoShareInput,
  SeasonCardKakaoShareLabels,
} from "../kakao.types";
import { shareDeckCardToKakao } from "../deckCard/shareDeckCardToKakao";

/**
 * Opens the KakaoTalk share picker with a season-card message.
 * Uses the same custom template as fan cards (REACT_APP_KAKAO_FAN_CARD_TEMPLATE_ID);
 * otherwise falls back to the default Feed template.
 */
export const shareSeasonCardToKakao = async (
  input: SeasonCardKakaoShareInput,
  labels?: SeasonCardKakaoShareLabels,
): Promise<void> => {
  await shareDeckCardToKakao(
    {
      kind: "season",
      mainCardId: input.seasonCardId,
      talentId: input.talentId,
      senderUserId: input.senderUserId,
      senderName: input.senderName,
      talentName: input.talentName,
      cardTitle: input.cardTitle,
      imageUrl: input.imageUrl,
      shortHint: input.shortHint,
    },
    labels,
  );
};
